import script from "./ICMMenuSubmenu.vue?vue&type=script&setup=true&lang=ts"
export * from "./ICMMenuSubmenu.vue?vue&type=script&setup=true&lang=ts"

import "./ICMMenuSubmenu.vue?vue&type=style&index=0&id=674d6f8e&lang=scss"

const __exports__ = script;

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QItem,QItemSection,QIcon,QMenu,QList});
